import { CasaDecimalUtils } from 'px-components';

export const DEFAULT_PRECISION = 20;

export const getPrecision = (item) => {
  if (item?.casasDecimais === null || item?.casasDecimais === undefined) {
    return CasaDecimalUtils.DEFAULT_CASAS_DECIMAIS;
  }
  return parseFloat(item.casasDecimais);
};

export default {
  DEFAULT_PRECISION,
  getPrecision,
};
